module.exports = __webpack_public_path__ + "static/media/ZAPTalent-Clientes-2.eda4a297.png";